import { request } from '@/utils/request/request'
// 保存一次图
export function saveSVGData(data) {
  return request({
    url: 'api/yicitu/v1/AddSVGData',
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: data
  })
}

// 根据配电室id获取一次图
export function getSVGDataByIdStr(data) {
  return request({
    url: 'api/yicitu/v1/GetSVGData',
    method: 'POST',
    params: data
  })
}

// 根据配电室id更新一次图
export function updateSVGDataByIdStr(data) {
  return request({
    url: 'api/yicitu/v1/UpdateSVGData',
    method: 'POST',
    params: data
  })
}

// 根据设备id 获取实时数据
export function getRealTimeStatus(data) {
  return request({
    url: '/api/yicitu/v1/GetYiCiTu',
    method: 'GET',
    params: data
  })
}

// 根据设备id 获取分组数据
export function GetSVGGroupData(data) {
  return request({
    url: '/api/yicitu/v1/GetSVGGroupData',
    method: 'POST',
    params: data
  })
}

// 根据设备id 组id 删除数据
export function DelSVGGroupData(data) {
  return request({
    url: '/api/yicitu/v1/DelSVGGroupData',
    method: 'POST',
    params: data
  })
}

// 根据项目id 获取设备树
export function GetProjectTreeYiCiTu(data) {
  return request({
    url: '/api/equipment/v1/GetProjectTree_YiCiTu',
    method: 'GET',
    params: data
  })
}

